const upperCase = (string) => {
    if (!string)
        return '';

    return string.toUpperCase().trim();
};

export default upperCase;